import { SyncedBy } from '~/@types/agents';
import { apiClient } from '~/api/client';

export type SyncParams = {
  ids: string[];
  type: ListSTI;
};

type SyncResponse = {
  data: SyncedBy[];
  error: string;
};

export const sync = async (params: SyncParams) =>
  apiClient.post<SyncResponse>('/loan_officers/sync', { ids: params.ids, type: params.type });
